export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="vv-g" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00F0FF" />
        <stop offset="1" stopColor="#FF8C00" />
      </linearGradient>
    </defs>
    <rect x="1.5" y="1.5" width="37" height="37" rx="9" stroke="url(#vv-g)" strokeWidth="2" />
    <path d="M23 6 L12 22 h6.5 L16 34 L29 17 h-6.5 L23 6 Z" fill="#00F0FF" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={compact ? 30 : 36} />
    <div className="leading-none">
      <span className="font-display font-extrabold tracking-tight text-[13px] sm:text-lg text-white whitespace-nowrap">
        TECNICO AUTO <span className="text-volt">&amp;</span> TRUCK
      </span>
      <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-slate-500 mt-1">
        Auto · Furgoni · Camion
      </span>
    </div>
  </div>
);
